import React, { useState, useEffect } from 'react';
import RagnaDataTable from '../ReactComponents/RagnaDataTable.jsx';
import axios from 'axios';
import moment from 'moment';
import { ajax_api, getAccess } from '../../Globals.jsx';
import { useOutlet, Outlet } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const SPItems = props => {
    const [codeItemType, setCodeItemType] = useState([]);// props.codeItemType;
    const [codeSession, setCodeSession] = useState([]);
    const [codeCouncil, setCodeCouncil] = useState([]);
    const [codeAuthor, setCodeAuthor] = useState([]);
    const [codeCoAuthor, setCodeCoAuthor] = useState([]);
    const [codeCategory, setCodeCategory] = useState([]);
    const [codeCommittee, setCodeCommittee] = useState([]);
    const [codeStatuses, setCodeStatuses] = useState([]);
    const maxTitleLength = 100;

    useEffect(_ => {
        axios.get(ajax_api + "items/getOptions")
            .then(response => {
                return response.data
            })
            .then(d => {
                setCodeItemType(d.itemTypes)
                setCodeSession([{ label: "No Session", value: -1 }, ...d.sessions])
                setCodeCouncil([{ label: "No Council", value: -1 }, ...d.councils])
                setCodeAuthor([{ label: "No Authors", value: -1 }, ...d.officials])
                setCodeCoAuthor([{ label: "No CoAuthors", value: -1 }, ...d.officials])
                setCodeCategory([{ label: "No Category", value: -1 }, ...d.categories])
                setCodeCommittee([{ label: "No Committee", value: -1 }, ...d.committees])
                setCodeStatuses([{ label: "Untracked", value: -1 }, ...d.trackingStatuses])
            })
            .catch(error => {
                console.log(error.response.data.error)
            })
    }, [])

    //datatable options
    const table_columns = [
        //{ display: "ID", col: "Id" },
        { display: "Item Code", col: "ItemCode" }, //, customValue: e => e.ItemCode + e.ItemType
        { display: "Item Type", col: "ItemType", dontOrder: true },
        { display: "Title", col: "Title", lg: true, customValue: v => v.Title.length > maxTitleLength ? v.Title.substring(0, maxTitleLength).trimEnd() + "..." : v.Title },
        { display: "Enacted Date", col: "EnactedDate", customValue: e => e.EnactedDate ? moment(e.EnactedDate).format("MMMM D, YYYY") : "null" },
        //{ display: "Status", col: "TrackingStatus", dontOrder: true, customValue: e => e.TrackingStatus ?? "UNTRACKED" },
        //{ display: "Approved", col: "Approved", dontOrder: true, customVal: v => v ? "Yes": "No", center: true },
        //{ display: "Approved Date", col: "ApprovedDate" },  
        //{ display: "Session", col: "Session", dontOrder: true, customVal: v => codeSession[v] },
        //{ display: "Council", col: "Council", dontOrder: true, center: true },// customVal: v => codeCouncil[v], center: true }
        //    ItemContent = "random stuff#1"
    ];
    const search_columns = [
        { display: "Title", col: "Title", keyword: false },
        { display: "Item Code", col: "ItemCode" },
        {
            display: "Item Type", col: "ItemType", options: codeItemType, blankOption: "[Match any]",
            customValue: v => codeItemType.filter(x => x.value === v)[0].display
        },
        { display: "Date Enacted", col: "EnactedDate", dateRange: true },
        { display: "Date Approved", col: "ApprovedDate", dateRange: true },
        { display: "Approved", col: "IsApproved", options: [{ value: true, label: "Yes" }, { value: false, label: "No" }], blankOption: "[Match any]" },
        {
            display: "Council", col: "CouncilId", options: codeCouncil, blankOption: "[Match any]", customValue:
                v => codeCouncil.filter(x => x.value === v)[0].display
        },
        {
            display: "Session", col: "SessionId", options: codeSession, blankOption: "[Match any]", customValue:
                v => codeSession.filter(x => x.value === v)[0].display
        },
        {
            display: "Main Author (Sole)", col: "SoleAuthor", options: codeAuthor, blankOption: "[Match any]", customValue:
                v => codeAuthor.filter(x => x.value === v)[0].display
        },
        {
            display: "Author (Multiple)", col: "AuthorList", options: codeAuthor, blankOption: "[Match any]", customValue:
                v => codeAuthor.filter(x => x.value === v)[0].display
        },
        {
            display: "CoAuthor", col: "Officials", options: codeCoAuthor, blankOption: "[Match any]", customValue:
                v => codeCoAuthor.filter(x => x.value === v)[0].display
        },
        {
            display: "Category", col: "Categories", options: codeCategory, blankOption: "[Match any]", customValue:
                v => codeCategory.filter(x => x.value === v)[0].display
        },
        {
            display: "Committee", col: "Committees", options: codeCommittee, blankOption: "[Match any]", customValue:
                v => codeCommittee.filter(x => x.value === v)[0].display
        },
        { display: "Item Content", col: "ItemContent", keyword: true },
        //{ display: "Tracking Status", col: "TrackingStatusSpitems", options: codeStatuses, blankOption: "[Match any]", customValue: 
        //v => codeStatuses.filter(x => x.value === v)[0].display },
    ];
    const outlet = useOutlet();


    return <>
        <Helmet>
            <title>LTS | Manage SP Items</title>
        </Helmet>
        {
            outlet != null ? <Outlet /> :
                <RagnaDataTable
                    //customEntrySizes={[5,10,50,100,1000]}
                    generalSearch={false}
                    title="SP Items"
                    columns={table_columns}
                    s_columns={search_columns}
                    defaultOrder={false}
                    maxPagination={8}
                    defaultOrderCol="ID"
                    url={ajax_api + "items/dtable"}//LTS/getSPItems
                    multiFilter={true}
                    multiFilterDivs={2}
                    multiFilterWidth={950}
                    multiFilterHideInputIf={{
                        col: "SoleAuthor",
                        condition: "!=",
                        value: -1,
                        colsToBeHidden: ["AuthorList", "Officials"]
                    }}
                    multiFilterFilterOptions={(currentCol, values, options) => {
                        if (["SoleAuthor", "AuthorList", "Officials", "Committees"].includes(currentCol)) {
                            if (values.CouncilId != "" && values.CouncilId != -1) {
                                return options.filter(c => c.councilIds == null || c.councilIds.includes(values.CouncilId));
                            }
                        }
                        return options
                    }}
                    actions={[

                        {
                            hideIf: !getAccess("55"),
                            action: "url", display: <><i className="fa fa-list" /> View</>,
                            content: d => `view/${d.Id}`
                        },
                        {
                            hideIf: !getAccess("57"),
                            action: "url", display: <><i className="fa fa-edit" /> Edit</>,
                            content: d => `edit/${d.Id}`
                        },
                        {
                            hideIf: !getAccess("58"),
                            action: "url_confirm", display: <><i className="fa fa-trash" /> Delete</>,
                            content: d => `${ajax_api}items/delete/${d.Id}`,
                            body: d => `Are you sure you want to delete SP Item with Item Code: ${d.ItemCode} ?`, title: "Delete Data"
                        },
                        //{
                        //    action: "modal", display: "Cust",
                        //    content: d => { return { title: "title modal", body: "full name: " + d.full_name, footer: <span>footer</span> } }
                        //},
                    ]}
                />
        }
    </>
}

export default SPItems;